import enseeiht from "assets/images/projects/enseeiht.png";
import nft from "assets/images/projects/website.png";

export const projectsList = [
  {
    id: 1,
    title: "NF7",
    logo: enseeiht,
    blurHash: "L4ADc400P*Zi4Tu1y;Qo00pH#YXl",
    link: "https://github.com/SouchonTheo",
    desc: `An NFT marketplace where you can check out the NFT Mint on the site. This site is on the Rinkeby blockchain.`,
    technologies: ["WEB3", "react", "ethersJS", "javascript", "MongoDB"]
  },
  {
    id: 2,
    title: "ensWEB",
    logo: nft,
    blurHash: "L4ADc400P*Zi4Tu1y;Qo00pH#YXl",
    link: "https://github.com/SouchonTheo/ensWebsite",
    desc: `This wesite`,
    technologies: ["react", "chakraUI", "javascript"]
  },
  {
    id: 3,
    title: "Deep learning Project",
    logo: enseeiht,
    blurHash: "L4ADc400P*Zi4Tu1y;Qo00pH#YXl",
    link: "https://github.com/SouchonTheo",
    desc: `This wesite`,
    technologies: ["react", "chakraUI", "javascript"]
  },
  
];
